import { useEffect, useState } from "react";
import { deleteStageService, getAllStagesService } from "../../../../Services/CRMAdminServices/CRMStagesService";
import { useGetRequestQuery } from "../../../../Hooks/useGetRequestQuery";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";
import { useMutationRequestQuery } from "../../../../Hooks/useMutationRequestQuery";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { useSafeNavigate } from "../../../../Hooks/useSafeNavigate";
const customStyles = {
    head: {
        style: {
            fontWeight: '800',
            color: '#0000ff',
            fontSize: '14px'
        },
    },
};
const CRMStages = () => {
    const [stages, setStages] = useState<any>([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedStageId, setSelectedStageId] = useState<number | null>(null);
    const queryClient = useQueryClient();
    const navigate = useSafeNavigate();

    const { data: stagesData, isLoading, isError } = useGetRequestQuery<any>(
        ['getAllStages'],
        getAllStagesService,
        { enabled: true }
    );

    useEffect(() => {
        if (stagesData && !isError && !isLoading) {
            const sortedStages = [...(stagesData?.data?.data || [])].sort((a, b) => a.orderBy - b.orderBy);
            setStages(sortedStages);
        }
    }, [stagesData, isError, isLoading]);

    const { mutate: deleteStage, isPending: isDeleting } = useMutationRequestQuery(
        "deleteStage",
        deleteStageService,
        {
            onSuccess: () => {
                toast.success("Stage deleted successfully.");
                queryClient.invalidateQueries({ queryKey: ["getAllStages"] });
                setDeleteModal(false);
            },
            onError: () => {
                toast.error("Failed to delete stage.");
                setDeleteModal(false);
            },
        }
    );

    const confirmDelete = (id: number) => {
        setSelectedStageId(id);
        setDeleteModal(true);
    };

    const handleDeleteClick = () => {
        if (selectedStageId) {
            deleteStage(selectedStageId);
        }
    };

    const columns = [
        {
            name: "Action",
            cell: (row: any) => (
                <ul className="action simple-list flex-row">
                    <li className="edit">
                        <Link to={`/EditStages/${row.stageId}`}>
                            <i className="icon-pencil-alt" />
                        </Link>
                    </li>
                    <li className="delete">
                        <a onClick={() => confirmDelete(row.stageId)} href="#">
                            <i className="icon-trash" />
                        </a>
                    </li>
                </ul> 
            ),
            // style: { minWidth: '9rem' },
            width : '7rem'
        },
        {
            name: "Stage Number",
            selector: (row: any) => row.orderBy,
            sortable: false,
            width : '9rem'
        },
        {
            name: "Stages",
            selector: (row: any) => row.name,
            sortable: false,
            width : '20rem'
        }
    ];

    return (
        <div className="px-4 pt-4" style={{ minHeight: '500px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
            <div style={{ borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', padding: '10px', backgroundColor: '#fff' }}>
                <div className="g-3 mb-2 d-flex justify-content-between align-items-center">
                    <h3 className="f-w-900 heading-color mx-3 py-2">Stages List</h3>
                    <Button color="primary" className="mx-3" onClick={() => navigate("/AddStages")}>Add Stage</Button>
                </div>
                {isLoading ? (
                    <div
                        style={{
                            borderRadius: '8px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            padding: '12px',
                            backgroundColor: '#fff',
                            textAlign: 'center',
                        }}
                        className='mt-4 mb-2'
                    >
                        <Spinner color="primary" />
                    </div>
                ) : stages.length !== 0 ? (
                    <DataTable
                        columns={columns}
                        data={stages}
                        // pagination
                        customStyles={customStyles}
                        responsive
                        defaultSortFieldId="orderBy"
                        defaultSortAsc={true}
                    />
                ) : (
                    <div
                        style={{
                            borderRadius: '8px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            padding: '12px',
                            backgroundColor: '#fff',
                            textAlign: 'center',
                        }}
                        className='mt-4 mb-2'
                    >
                        <h6>No Stages data available.</h6>
                    </div>
                )}

            </div>
            <Modal isOpen={deleteModal} toggle={() => setDeleteModal(!deleteModal)} centered>
                <ModalHeader toggle={() => setDeleteModal(!deleteModal)}>Confirm Delete</ModalHeader>
                <ModalBody>Are you sure you want to delete this stage?</ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => setDeleteModal(false)}>Cancel</Button>
                    <Button color="danger" onClick={handleDeleteClick} disabled={isDeleting}>
                        {isDeleting ? "Deleting..." : "Delete"}
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default CRMStages;